import { Col, Row } from '@advanza/grid'
import { Icon } from '@advanza/ui'
import clsx from 'clsx'
import style from 'components/ui/navigation.module.css'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import Navigation from './Navigation'
import NavigationTop from './NavigationTop'
import stylePage from './Page.module.css'

interface Props {
    title?: string
    children?: React.ReactNode
    padding?: boolean
    current?: string | null
    hideTop?: boolean
    className?: string
}

const Page = ({
    title = ' ',
    children,
    padding = true,
    current = null,
    hideTop = false,
    className = '',
}: Props) => {
    const [isCollapsed, setIsCollapsed] = useState(document.documentElement.clientWidth < 1024)
    useEffect(() => {
        if (isCollapsed) {
            setIsCollapsed(false)
        }
    }, [current])

    return (
        <div className={clsx(stylePage.root, className)}>
            <Helmet>
                <title>{'Office' + (title ? ' - ' + title : '')}</title>
            </Helmet>
            <Row style={{ maxWidth: '100%' }}>
                <Col
                    xs
                    style={{ maxWidth: isCollapsed ? 50 : 280 }}
                    onClick={() => isCollapsed && setIsCollapsed(false)}>
                    <Navigation isCollapsed={isCollapsed} current={current}>
                        <button
                            className={style.toggle}
                            onClick={() => setIsCollapsed(!isCollapsed)}>
                            <Icon
                                name={isCollapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_left'}
                            />
                        </button>
                    </Navigation>
                </Col>
                <Col xs style={{ maxWidth: `calc(100% - ${isCollapsed ? 50 : 240}px)` }}>
                    {!hideTop && <NavigationTop title={title} />}
                    <div className={padding ? style.padding : ''}>{children}</div>
                </Col>
            </Row>
        </div>
    )
}

export default Page
